<form
    [formGroup]="form"
    class="input-grid-gaps grid-6col mt-1"
>
    <app-date-input
        id="validFrom"
        class="fr-2"
        label="person.authorization.fields.validFrom"
        [form]="form"
    ></app-date-input>

    <app-date-input
        id="validTo"
        class="fr-2"
        label="person.authorization.fields.validTo"
        [form]="form"
        timeType="endOfDay"
    ></app-date-input>

    <app-select-input
        id="authorizationType"
        class="fr-3"
        label="person.authorization.fields.authorizationType"
        [form]="form"
        [staticOptions]="personAuthorizationEnumOptions"
        valueKey="value"
        [autoDisplayFirst]="true"
    ></app-select-input>

    <!-- Authorized person contact info -->
    <div class="fr-6">
        @if (form.value.authorizationType) {
            {{ ('person.enum.authorization.' + form.value.authorizationType) | translate }} {{ 'person.authorization.forPerson' | translate }}:
        }
    </div>

    <app-text-input
        id="titlesBefore"
        class="fr-1"
        [form]="form"
    ></app-text-input>

    <app-text-input
        id="name"
        class="fr-2"
        [form]="form"
    ></app-text-input>

    <app-text-input
        id="surname"
        class="fr-2"
        [form]="form"
    ></app-text-input>

    <app-text-input
        id="titlesAfter"
        class="fr-1"
        [form]="form"
    ></app-text-input>

    <app-phone-input
        id="mobile"
        class="fr-2"
        icon="pi-mobile"
        [form]="form"
    ></app-phone-input>

    <app-phone-input
        id="phone"
        class="fr-2"
        [form]="form"
    ></app-phone-input>

    <app-email-input
        id="email"
        class="fr-2"
        [label]="'inputs.email' | translate"
        [form]="form"
    ></app-email-input>

    <app-address-input
        id="address"
        class="fr-6"
        [form]="form"
    ></app-address-input>


    <!-- Additional info for court appointed person -->
    @if (form.value.authorizationType === AuthorizationEnum.GUARDIAN_APPROVED
    || form.value.authorizationType === AuthorizationEnum.REPRESENTATIVE_APPROVED
    || form.value.authorizationType === AuthorizationEnum.SUPPORTER_APPROVED) {
        <div class="fr-6">
            {{ 'person.authorization.additionalInfoForJudistical' | translate }}:
        </div>

        <app-text-input
            id="basis"
            class="fr-2"
            label="person.authorization.fields.basis"
            [form]="form"
        ></app-text-input>

        <app-text-input
            id="referenceNumber"
            class="fr-2"
            label="person.authorization.fields.referenceNumber"
            [form]="form"
        ></app-text-input>

        <app-check-input
            id="isRelative"
            class="fr-2"
            label="person.authorization.fields.isRelative"
            [form]="form"
        ></app-check-input>
    }

    <!-- Additional info for municipal worker -->
    @if (form.value.authorizationType === AuthorizationEnum.MUNICIPALITY_WORKER) {
        <div class="fr-6">
            {{ 'person.authorization.additionalInfoForMunicipal' | translate }}:
        </div>

        <app-select-input
            id="municipality"
            class="fr-4"
            label="person.authorization.fields.municipality"
            [form]="form"
            [infiniteScroll]="store.municipalityScroll"
            [valueKey]="'id'"
            [labelKey]="'name'"
            [filterBy]="'name'"
        ></app-select-input>
    }

    <app-text-input
        id="note"
        class="fr-6"
        [form]="form"
    ></app-text-input>


</form>
